import gsap from "gsap";

export default class Marquee {
    constructor() {
        this.marquees = document.querySelectorAll('.marquee');
        if (this.marquees.length) {
            window.addEventListener('load', () => this.init());
        }
    }

    init() {
        this.marquees.forEach((marquee) => {
            const marqueeTrack = marquee.querySelector(".marquee-track");
            const originalItems = Array.from(marquee.querySelectorAll(".marquee-item"));
            const speed = parseFloat(marquee.getAttribute('data-speed')) || 30;

            if (!marqueeTrack || originalItems.length === 0) return;

            const originalHTML = marqueeTrack.innerHTML;

            let clones = 0;
            while (marqueeTrack.scrollWidth < window.innerWidth * 2 && clones < 10) {
                marqueeTrack.insertAdjacentHTML('beforeend', originalHTML);
                clones++;
            }

            const firstClone = marqueeTrack.children[originalItems.length];
            if (!firstClone) return;

            const exactTravelDistance = firstClone.offsetLeft - originalItems[0].offsetLeft;

            const marqueeAnimation = gsap.to(marqueeTrack, {
                x: -exactTravelDistance,
                duration: speed,
                ease: "none",
                repeat: -1,
            });

            marquee.addEventListener("mouseenter", () => marqueeAnimation.pause());
            marquee.addEventListener("mouseleave", () => marqueeAnimation.play());

            this.animateArrows(marquee);
        });
    }
    animateArrows(marquee) {
        const arrows = marquee.querySelectorAll('.arrow');

        arrows.forEach((arrow, index) => {
            gsap.to(arrow, {
                rotation: 360,
                duration: 8,
                repeat: -1,
                ease: 'linear',
                transformOrigin: '50% 50%',
                delay: (index * (90 / 360)) * 8,
            });
        });
    }
}
